import { Activity } from "../types";
import { SenderReceiverText } from "./SenderReceiverText";
import { UsersPictures } from "./UsersPictures";

export function ActivityRow({ activity }: { activity: Activity }) {
  return (
    <div className="activity-row">
      <div className="activity-user-image">
        <UsersPictures sender={activity.sender} receiver={activity.receiver} />
      </div>
      <div className="activity-description">
        <SenderReceiverText activity={activity} />
        {activity.reason &&
          <p className="activity-reason">{activity.reason}</p>
        }
      </div>
    </div>
  )
}